import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b0aa508")

_pushScopeId("data-v-2b0aa508")
const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ion_item, {
      class: {'ion-invalid': _ctx.errorMessage, 'ion-touched': _ctx.errorMessage }
    }, {
      default: _withId(() => [
        _createVNode(_component_ion_label, { position: "stacked" }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_input, _mergeProps({
          onChange: _ctx.handleChange,
          onBlur: _ctx.handleChange,
          type: _ctx.showPassword ? 'text' : 'password',
          value: _ctx.modelValue
        }, _ctx.$attrs), null, 16, ["onChange", "onBlur", "type", "value"]),
        _createVNode(_component_ion_icon, {
          slot: "end",
          icon: _ctx.showPassword ? _ctx.eye : _ctx.eyeOff,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = ! _ctx.showPassword))
        }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
})